import { useEffect } from 'react';

const FaviconChecker = () => {
  useEffect(() => {
    const favicon = document.querySelector("link[rel~='icon']");
    const defaultFavicon =
      'https://assets.nextorder.co/favicons/forkAndKnife.ico';

    if (favicon) {
      const testImg = document.createElement('img');
      testImg.src = favicon.href;

      testImg.onerror = () => {
        console.warn('Favicon failed to load. Replacing with default.');
        favicon.href = defaultFavicon;
      };
    }
  }, []);

  return null;
};

export default FaviconChecker;
